import { render, staticRenderFns } from "./SpinnerLoaderGlobal.vue?vue&type=template&id=39fd4f4f&"
import script from "./SpinnerLoaderGlobal.vue?vue&type=script&lang=js&"
export * from "./SpinnerLoaderGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports